import { render } from "./DialogBox.vue?vue&type=template&id=05739daa&ts=true"
import script from "./DialogBox.vue?vue&type=script&lang=ts"
export * from "./DialogBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__